import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    roles: [],
    role: {},
    new_role: {},
  },
  actions,
  mutations,
  getters,
};
